import { Typography } from "@mui/material";
import NumberFormatterUtils from "./numberFormatterUtils";

/**
 * renderCell ที่ใช้แสดงตัวเลข + สีตามค่าบวก/ลบ
 * @param value ตัวเลขที่ต้องการแสดง
 * @param options ตัวเลือกเพิ่มเติม เช่น unit (%), สี override
 */
export const renderColoredNumberCell = (
  value: number | string | null | undefined,
  options?: {
    showPlus?: boolean; // แสดง "+" ถ้าค่าบวก
    showPercent?: boolean; // เติม "%" ต่อท้าย
    invertColor?: boolean; // กลับความหมายของสี (เช่นบวก=เขียว)
    reversePositiveToNegative?: boolean; // ✅ กลับสัญลักษณ์ของค่า และกลับสีตามค่าที่กลับ
  }
) => {
  if (value == null || value === "" || isNaN(Number(value))) return null;

  let num = Number(value);

  // ✅ ถ้ามี reversePositiveToNegative ให้กลับสัญลักษณ์ของค่า
  if (options?.reversePositiveToNegative) {
    num = -num;
  }

  // ✅ เลือกสีตามค่า (หลังกลับ)
  const color =
    num < 0
      ? options?.invertColor
        ? "var(--red)"
        : "var(--green)" // ลบ → เขียว
      : num > 0
      ? options?.invertColor
        ? "var(--green)"
        : "var(--red)" // บวก → แดง
      : "inherit";

  const formatted = NumberFormatterUtils.numberFormat(num);

  // ✅ แสดงเครื่องหมาย + ถ้าค่าบวก
  const display = `${options?.showPlus && num > 0 ? "+" : ""}${formatted}${
    options?.showPercent ? "%" : ""
  }`;

  return <Typography color={color}>{display}</Typography>;
};